import script from "./CryptocurrencyExchangeNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./CryptocurrencyExchangeNotice.vue?vue&type=script&setup=true&lang=ts"

import "./CryptocurrencyExchangeNotice.vue?vue&type=style&index=0&id=4bb757be&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb757be"]])

export default __exports__